// extracted by mini-css-extract-plugin
module.exports = {"blockListTableItem":"QuHNs-2x","blockListTableItemButton":"_2d5_4zNw"};